import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { clearSession, getToken, hasValidSession, installAuthInterceptors, refreshSessionUser } from './lib/session';
import { startFirebaseAccess, withTimeout } from './lib/firebase';

installAuthInterceptors();
if (getToken() && !hasValidSession()) clearSession();

// Permissions changed by the administrator reach open sessions in the background.
if (hasValidSession()) refreshSessionUser().catch(() => {});

// The pages that read Firestore need the Firebase sign-in first. It is usually instant;
// this screen only appears when the pass must be renewed and the server is slow to answer.
const StartupScreen = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 400);
    return () => clearTimeout(timer);
  }, []);
  if (!visible) return null;
  return (
    <div className="flex min-h-screen items-center justify-center gap-[12px] bg-mist font-sans" role="status">
      <span className="h-5 w-5 animate-spin rounded-full border-2 border-solid border-black/10 border-t-brand-600" />
      <span className="text-[14px] text-black/50">Connexion sécurisée…</span>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<StartupScreen />);
withTimeout(startFirebaseAccess(), 30000).then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
